// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 223) return "client/js/home-page.js";
	if (chunkId === 52) return "client/js/announcement-page.js";
	if (chunkId === 381) return "client/js/announcement-dateil-page.js";
	if (chunkId === 760) return "client/js/video-page.js";
	if (chunkId === 678) return "client/js/video-dateil-page.js";
	if (chunkId === 331) return "client/js/project-page.js";
	if (chunkId === 669) return "client/js/province-page.js";
	if (chunkId === 310) return "client/js/psc-page.js";
	if (chunkId === 628) return "client/js/document-page.js";
	if (chunkId === 806) return "client/js/other-page.js";
	if (chunkId === 957) return "client/js/notfound-page.js";
	if (chunkId === 597) return "client/js/597.js";
	if (chunkId === 443) return "client/js/443.js";
	// return url for filenames based on template
	return undefined;
};